import Ajax from "./Ajax"
const GetFurnishing = async() => {
    const response = await Ajax({
        url: `/project/furnishing?limit=false`,
        token: true
    })
    return response.data.result
}
export default GetFurnishing